import React, { useState } from 'react';

const initialForm = {
  title: '',
  platform: 'instagram',
  status: 'idea',
  publish_at: '',
  campaign: '',
  caption: '',
};

export const ClinicContentPanel = ({ workspace, onCreateTask, onUpdateTask, saving, canEdit }) => {
  const [form, setForm] = useState(initialForm);

  const submit = async (event) => {
    event.preventDefault();
    const success = await onCreateTask(form);
    if (success) setForm(initialForm);
  };

  return (
    <section className="grid gap-5 xl:grid-cols-[0.9fr_1.1fr]" data-testid="clinic-content-panel">
      <form onSubmit={submit} className="rounded-[28px] border border-white/60 bg-white/95 p-6 shadow-[0_20px_60px_rgba(15,23,42,0.08)]" data-testid="clinic-content-form">
        <p className="text-xs uppercase tracking-[0.24em] text-[#0f766e]">Community manager</p>
        <h2 className="mt-2 text-2xl font-black text-slate-900">Nueva pieza de contenido</h2>
        <div className="mt-3 rounded-[22px] bg-[#f8fafc] px-4 py-3 text-sm text-slate-600" data-testid="clinic-content-integration-note">
          Calendario editorial operativo hoy. Las conexiones sociales LIVE quedan listas para enchufar cuando entren credenciales finales.
        </div>
        <div className="mt-5 space-y-4">
          <input data-testid="clinic-content-title-input" className="w-full rounded-2xl border border-slate-200 px-4 py-3" placeholder="Título de la pieza" value={form.title} onChange={(event) => setForm((prev) => ({ ...prev, title: event.target.value }))} required />
          <div className="grid gap-4 sm:grid-cols-2">
            <select data-testid="clinic-content-platform-select" className="rounded-2xl border border-slate-200 px-4 py-3" value={form.platform} onChange={(event) => setForm((prev) => ({ ...prev, platform: event.target.value }))}>
              {workspace.content_platforms.map((platform) => <option key={platform} value={platform}>{platform}</option>)}
            </select>
            <select data-testid="clinic-content-status-select" className="rounded-2xl border border-slate-200 px-4 py-3" value={form.status} onChange={(event) => setForm((prev) => ({ ...prev, status: event.target.value }))}>
              {workspace.content_statuses.map((status) => <option key={status} value={status}>{status}</option>)}
            </select>
          </div>
          <input data-testid="clinic-content-publish-at-input" type="datetime-local" className="w-full rounded-2xl border border-slate-200 px-4 py-3" value={form.publish_at} onChange={(event) => setForm((prev) => ({ ...prev, publish_at: event.target.value }))} />
          <input data-testid="clinic-content-campaign-input" className="w-full rounded-2xl border border-slate-200 px-4 py-3" placeholder="Campaña" value={form.campaign} onChange={(event) => setForm((prev) => ({ ...prev, campaign: event.target.value }))} />
          <textarea data-testid="clinic-content-caption-input" className="min-h-[120px] w-full rounded-2xl border border-slate-200 px-4 py-3" placeholder="Caption / idea" value={form.caption} onChange={(event) => setForm((prev) => ({ ...prev, caption: event.target.value }))} />
          <button data-testid="clinic-content-submit-button" type="submit" className="w-full rounded-full bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-slate-700" disabled={saving === 'content-create' || !canEdit}>
            {saving === 'content-create' ? 'Guardando…' : 'Guardar pieza'}
          </button>
        </div>
      </form>

      <div className="space-y-4" data-testid="clinic-content-list">
        {workspace.content_tasks?.length ? workspace.content_tasks.map((task) => (
          <article key={task.id} className="rounded-[28px] border border-white/60 bg-white/95 p-5 shadow-[0_16px_40px_rgba(15,23,42,0.06)]" data-testid={`clinic-content-item-${task.id}`}>
            <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
              <div>
                <p className="text-lg font-bold text-slate-900" data-testid={`clinic-content-title-${task.id}`}>{task.title}</p>
                <p className="text-sm text-slate-500">{task.platform} · {task.publish_at ? new Date(task.publish_at).toLocaleString('es-ES') : 'sin fecha'}</p>
                <p className="mt-2 text-sm text-slate-600">{task.caption || 'Sin copy todavía.'}</p>
              </div>
              <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600" data-testid={`clinic-content-status-${task.id}`}>{task.status}</span>
            </div>
            {canEdit && (
              <div className="mt-4 flex flex-wrap gap-2">
                <button type="button" onClick={() => onUpdateTask(task.id, { status: 'programado' })} className="rounded-full bg-[#dbeafe] px-4 py-2 text-sm font-semibold text-[#1d4ed8]" data-testid={`clinic-content-schedule-${task.id}`}>Programar</button>
                <button type="button" onClick={() => onUpdateTask(task.id, { status: 'publicado' })} className="rounded-full bg-[#dcfce7] px-4 py-2 text-sm font-semibold text-[#166534]" data-testid={`clinic-content-publish-${task.id}`}>Publicado</button>
              </div>
            )}
          </article>
        )) : <div className="rounded-[28px] border border-dashed border-slate-300 bg-white/80 p-8 text-sm text-slate-500" data-testid="clinic-content-empty">El hub creativo está vacío por ahora.</div>}
      </div>
    </section>
  );
};
